import * as React from 'react'
import styled from 'styled-components'
import { getShortenedAddress } from '../../utils/address'
import { FbEnrichedUser } from '../../interfaces/User'
import ProfileImage from '../profile/image'
import { useRouter } from 'next/router'

const CreatorDiv = styled.div<{ noOutline?: boolean }>`
  display: inline-flex;
  align-items: center;
  flex-direction: ${(props) => (props.noOutline ? 'row-reverse' : 'row')};
  border-radius: ${(props) => (props.noOutline ? '0' : '30px')};
  height: 24px;
  background: ${(props) => (props.noOutline ? 'none' : '#444')};
  width: fit-content;
  padding: ${(props) => (props.noOutline ? '0' : '8px')};
  margin-right: 16px;
  cursor: pointer;
`

const Creator = styled.div`
  font-weight: 600;
  color: white;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin-left: 8px;
  margin-right: 8px;
  font-size: 1rem;
`

type Props = {
  address: string
  user?: FbEnrichedUser
  noOutline?: boolean
}

const PreviewSocial = ({ address, user, noOutline }: Props): JSX.Element => {
  const router = useRouter()
  const [hover, setHover] = React.useState(false)

  const hoverState = {
    textDecoration: hover ? 'underline' : 'none',
  }

  const handleClick = (e: React.MouseEvent): void => {
    e.stopPropagation()
    router.push(`/${address}`)
  }

  return (
    <>
      <CreatorDiv
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        onClick={handleClick}
        noOutline={noOutline}
      >
        <ProfileImage item={user} size={25} />
        <Creator style={hoverState}>{user?.displayName ?? getShortenedAddress(address)}</Creator>
      </CreatorDiv>
    </>
  )
}

export default PreviewSocial
